module.exports = "pegasus/assets/themelp1/creative/103.png";